import { render } from "./AssignmentsTable.vue?vue&type=template&id=8c5a4a14&scoped=true"
import script from "./AssignmentsTable.vue?vue&type=script&lang=js"
export * from "./AssignmentsTable.vue?vue&type=script&lang=js"

import "./AssignmentsTable.vue?vue&type=style&index=0&id=8c5a4a14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c5a4a14"]])

export default __exports__